export const ADD_NEW_PRICE_TYPES = {
  ADD_NEW_PRICE: 'ADD_NEW_PRICE',
  UPLOAD_CSV: 'UPLOAD_CSV',
} as const;

export const PRICE_COMPONENT_MODES = {
  ADD_PRICE_MODE: 'ADD_PRICE',
  EDIT_PRICE_MODE: 'EDIT_PRICE',
} as const;

export interface FieldConfig {
  name: string;
  label: string;
  type: 'text' | 'number' | 'select' | 'radio';
  options?: {label: string; value: string}[];
}

// These are the fields that will be shown in the form when adding a new price
export const categoryFieldsConfig: Record<string, FieldConfig[]> = {
  consultation: [
    {
      name: 'doctorId',
      label: 'Consultant',
      type: 'select',
    },
    {
      name: 'consultationFee',
      label: 'New Patient Consultation',
      type: 'number',
    },
    {
      name: 'followupFee',
      label: 'Follow Up',
      type: 'number',
    },
  ],
  diagnostic: [
    {name: 'ccsdCode', label: 'CCSD Code', type: 'text'},
    {name: 'description', label: 'Test', type: 'text'},
    {name: 'price', label: 'Fee', type: 'number'},
  ],
  refractive: [
    {name: 'ccsdCode', label: 'CCSD Code', type: 'text'},
    {name: 'description', label: 'Procedure Description', type: 'text'},
    {
      name: 'eyeOption',
      label: 'One Eye/Both',
      type: 'radio',
      options: [
        {label: 'One Eye', value: 'one'},
        {label: 'Both', value: 'both'},
      ],
    },
    {name: 'price', label: 'Procedure Price', type: 'number'},
  ],
  retinal: [],
  oculoplastics: [],
  corneal: [],
  glaucoma: [],
  addons: [
    {name: 'ccsdCode', label: 'CCSD Code', type: 'text'},
    {name: 'description', label: 'Add-on Description', type: 'text'},
    {
      name: 'eyeOption',
      label: 'One Eye/Both',
      type: 'radio',
      options: [
        {label: 'One Eye', value: 'one'},
        {label: 'Both', value: 'both'},
      ],
    },
    {name: 'price', label: 'Add-on Price', type: 'number'},
  ],
};

// Populating remaining categories same as 'refractive'
['retinal', 'oculoplastics', 'corneal', 'glaucoma'].forEach(category => {
  categoryFieldsConfig[category] = categoryFieldsConfig['refractive'];
});
